export const decodePaymentEmailToken = (token) => {
    try {
        // base64url decode
        const base64 = token.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = JSON.parse(atob(base64));
        return {
        paymentUuid: decoded.p,
        organisationId: decoded.o,
        };
    } catch {
        return null;
    }
};